import type { ChipProps } from '@mui/material';
import MuiChip from '@mui/material/Chip';
import { forwardRef } from 'react';

const Chip = forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  return <MuiChip ref={ref} {...props} />;
});
Chip.displayName = 'Chip';
export default Chip;
